import { queryClient } from '.';
import { buildQueryDescriptor } from './utils';

export default function prefetchBaseQuery(url, client, params) {
  const { queryKey, queryFn, restParams } = buildQueryDescriptor(url, client, params);

  return queryClient.prefetchQuery({ queryKey, queryFn, ...restParams });
};

